import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { useDateRanges } from '../../../shared/lib/hooks/UseDateRanges'
import { ILanguageComplianceFilter } from './types/LanguageComplianceFilter.interface'
import { RootState } from '../../../app/store/Store'
import { IPagination } from '../../../shared/types/Pagination.interface'

type LanguageComplianceState = {
  filters: ILanguageComplianceFilter
  pagination: IPagination
}

const dateRanges = useDateRanges()

const languageComplianceSlice = createSlice({
  name: 'languageCompliance',
  initialState: {
    filters: {
      dateRange: dateRanges.month,
      hidden: false,
    },
    pagination: {
      current: 1,
      pageSize: 10,
      total: 1,
    },
  } as LanguageComplianceState,
  reducers: {
    setLanguageComplianceFilter: (
      state: LanguageComplianceState,
      { payload }: PayloadAction<ILanguageComplianceFilter>,
    ) => {
      state.filters = { ...state.filters, ...payload }
    },
    setLanguageCompliancePagination: (
      state: LanguageComplianceState,
      action: PayloadAction<IPagination>,
    ) => {
      state.pagination = action.payload
    },
  },
})

export const { setLanguageComplianceFilter, setLanguageCompliancePagination } =
  languageComplianceSlice.actions

export const selectLanguageComplianceFilter = (state: RootState) =>
  state.root.languageCompliance.filters

export const selectLanguageCompliancePagination = (state: RootState) =>
  state.root.languageCompliance.pagination

export default languageComplianceSlice.reducer
